<app-base-modal
  title="{{ 'USER_FORM.CREATE_ADMIN_MODAL_TITLE' | translate }}"
  [showClose]="showClose"
  (closeCross)="onModalClose()"
>
  <ng-container modal-body-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="py-4">
      <div class="form-section mb-3 p-0">
        <app-form-section-header
          [title]="'USER_FORM.PERSONAL_INFORMATION' | translate"
          [icon]="'../../assets/icon/user.svg'"
        ></app-form-section-header>

        <div class="input-wrapper mb-2">
          <label for="firstName">
            {{ 'PERSONAL_INFO_FORM.NAME' | translate }}
            <span class="text-danger">*</span>
          </label>
          <app-icam-input
            formControlName="firstName"
            inputType="text"
            [isSlim]="true"
            [placeholder]="'USER_FORM.FIRST_NAME_PLACEHOLDER' | translate"
            [ngClass]="isLight ? 'light' : 'dark'"
          />
          @if (form.get('firstName')?.invalid && form.get('firstName')?.touched) {
            <div class="invalid-feedback d-block">
              {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
            </div>
          }
        </div>

        <div class="input-wrapper mb-2">
          <label for="lastName">
            {{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}
            <span class="text-danger">*</span>
          </label>
          <app-icam-input
            formControlName="lastName"
            inputType="text"
            [isSlim]="true"
            [placeholder]="'USER_FORM.LAST_NAME_PLACEHOLDER' | translate"
            [ngClass]="isLight ? 'light' : 'dark'"
          />
          @if (form.get('lastName')?.invalid && form.get('lastName')?.touched) {
            <div class="invalid-feedback d-block">
              {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
            </div>
          }
        </div>

        <div class="input-wrapper mb-2">
          <label for="email">
            Email
            <span class="text-danger">*</span>
          </label>
          <app-icam-input
            formControlName="email"
            inputType="email"
            [isSlim]="true"
            [placeholder]="'USER_FORM.EMAIL_PLACEHOLDER' | translate"
            [ngClass]="isLight ? 'light' : 'dark'"
          />
          @if (form.get('email')?.invalid && form.get('email')?.touched) {
            <div class="invalid-feedback d-block">
              @if (form.get('email')?.hasError('required')) {
                <span>{{ 'USER_FORM.REQUIRED_FIELD' | translate }}</span>
              }
              @if (form.get('email')?.hasError('email')) {
                <span>{{ 'COMMON.INVALID_EMAIL' | translate }}</span>
              }
            </div>
          }
        </div>

        <div class="input-wrapper mb-2">
          <label for="mobilePhone">{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}</label>
          <app-icam-input
            formControlName="mobilePhone"
            inputType="tel"
            [isSlim]="true"
            [placeholder]="'USER_FORM.PHONE_PLACEHOLDER' | translate"
            [ngClass]="isLight ? 'light' : 'dark'"
          />
        </div>
      </div>

      <div class="form-section mb-3 p-0">
        <app-form-section-header
          [title]="'USER_FORM.CREDENTIALS' | translate"
          [icon]="'../../assets/icon/unlocked-outlined-white.svg'"
        ></app-form-section-header>

        <div class="input-wrapper mb-2">
          <label for="password">
            {{ 'USER_FORM.PASSWORD' | translate }}
            <span class="text-danger">*</span>
          </label>
          <app-icam-input
            formControlName="password"
            inputType="text"
            [isSlim]="true"
            [placeholder]="'USER_FORM.PASSWORD_PLACEHOLDER' | translate"
            [ngClass]="isLight ? 'light' : 'dark'"
          />
          @if (form.get('password')?.invalid && (form.get('password')?.touched || form.get('password')?.dirty)) {
            <div class="invalid-feedback d-block">
              @if (form.get('password')?.hasError('required')) {
                <span>{{ 'USER_FORM.REQUIRED_FIELD' | translate }}</span>
              }
              @if (form.get('password')?.hasError('minlength')) {
                <span>{{ 'USER_FORM.PASSWORD_TOO_SHORT' | translate }}</span>
              }
            </div>
          }
        </div>
      </div>

      <div class="form-section mb-3 p-0">
        <app-form-section-header
          [title]="'USER_FORM.PERMISSIONS' | translate"
          [icon]="'../../assets/icon/add-section-white.svg'"
        ></app-form-section-header>

        <div class="permissions-grid">
          @for (permission of availablePermissions; track permission) {
            <div class="permission-item">
              <button
                type="button"
                class="btn rounded d-flex align-items-center justify-content-center mb-1 w-100 permission-button"
                [ngStyle]="
                  isPermissionSelected(permission.id.toString())
                    ? {
                        background: '#E30613',
                        borderColor: '#E30613',
                        color: '#fff'
                      }
                    : {
                        background: '#fff',
                        borderColor: '#6c757d',
                        color: '#6c757d'
                      }
                "
                (click)="
                  onPermissionSelection(permission.id.toString(), !isPermissionSelected(permission.id.toString()))
                "
              >
                <img
                  [src]="
                    '../../assets/icon/' +
                    ((permission.id + '').toLowerCase() === 'request'
                      ? 'info-circle'
                      : (permission.id + '').toLowerCase() === 'final-users'
                        ? 'home'
                        : (permission.id + '').toLowerCase()) +
                    (isPermissionSelected(permission.id.toString()) ? '-white.svg' : '-light.svg')
                  "
                  alt="permission-icon"
                  class="img-fluid"
                  style="width: 32px; height: 32px; object-fit: contain"
                />
              </button>
              <div
                class="small fw-semibold text-center w-100"
                [ngStyle]="{
                  color: !isLight ? '#ffffff' : isPermissionSelected(permission.id.toString()) ? '#111' : '#6c757d'
                }"
              >
                {{ permission.value | translate }}
              </div>
            </div>
          }
        </div>
      </div>

      <div class="form-section mb-3 p-0">
        <div class="mb-4">
          <app-divider [orientation]="'horizontal'" />
        </div>
        <div class="input-wrapper mb-2">
          <label for="templateLanguage">
            {{ 'USER_FORM.TEMPLATE_LANGUAGE' | translate }}
            <span class="text-danger">*</span>
          </label>
          <select
            id="templateLanguage"
            formControlName="templateLanguage"
            class="form-select filter-select rounded-0 fw-bold mt-1"
            [ngClass]="isLight ? 'light' : 'dark'"
            [class.is-invalid]="form.get('templateLanguage')?.invalid && form.get('templateLanguage')?.touched"
            [disabled]="isLoadingTemplate"
            (change)="onTemplateLanguageChange()"
          >
            <option value="">{{ 'COMMON.CHOOSE_VALUE' | translate }}</option>
            @for (language of availableLanguages; track language) {
              <option [value]="language.lang">
                {{ language.lang?.toUpperCase() }}
              </option>
            }
          </select>
          @if (
            form.get('templateLanguage')?.invalid &&
            (form.get('templateLanguage')?.touched || form.get('templateLanguage')?.dirty)
          ) {
            <div class="invalid-feedback">
              {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
            </div>
          }
        </div>

        @if (isLoadingTemplate) {
          <div class="text-center my-4 py-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
            </div>
            <p class="mt-3 mb-0">{{ 'COMMON.LOADING' | translate }}</p>
          </div>
        }

        @if (!isLoadingTemplate) {
          <div class="input-wrapper mb-2">
            <label for="welcomeSubject">{{ 'USER_FORM.TEMPLATE_MAIL_SUBJECT' | translate }}</label>
            <app-icam-input
              formControlName="welcomeSubject"
              inputType="text"
              [isSlim]="true"
              [placeholder]="'USER_FORM.SUBJECT_PLACEHOLDER' | translate"
              [ngClass]="isLight ? 'light' : 'dark'"
            />
          </div>
          <div class="input-wrapper mb-2">
            <label for="templateMail">{{ 'USER_FORM.TEMPLATE_MAIL' | translate }}</label>
            <textarea
              id="templateMail"
              formControlName="templateMail"
              class="form-control rounded-0"
              rows="20"
              style="max-height: 600px"
              [placeholder]="'USER_FORM.TEMPLATE_PLACEHOLDER' | translate"
              [ngClass]="isLight ? 'light' : 'dark'"
            ></textarea>
          </div>
        }
      </div>
    </form>
  </ng-container>

  @if (showBtns) {
    <ng-container modal-footer-content>
      @if (submitError) {
        <div class="text-danger small w-100 mb-2">{{ submitError | translate }}</div>
      }
      @if (!isLoading) {
        <div class="d-flex align-items-center w-100 justify-content-between">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="button" class="btn btn-danger" (click)="onSubmit()" [disabled]="form.invalid">
            {{ 'USER_FORM.CREATE_ADMIN' | translate }}
          </button>
        </div>
      } @else {
        <div class="d-flex w-100 justify-content-center">
          <div class="spinner-border" role="status"></div>
        </div>
      }
      <ng-template #spinner>
        <div class="d-flex w-100 justify-content-center">
          <div class="spinner-border" role="status"></div>
        </div>
      </ng-template>
    </ng-container>
  }
</app-base-modal>
